import React, { forwardRef, ReactNode } from 'react';
import { Container as ChakraContainer, ContainerProps } from '@chakra-ui/react';

interface Props extends ContainerProps {
  children: ReactNode;
}

export const Container = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraContainer maxW="container.xl" ref={ref} {...props}>
        {children}
      </ChakraContainer>
    );
  }
);
export type { Props as ContainerProps };
